// src/contexts/ThemeContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    try {
      const storedTheme = window.localStorage.getItem('themeMode');
      return storedTheme || 'light';
    } catch {
      return 'light';
    }
  });
  const [customTheme, setCustomTheme] = useState({});

  const themeToggler = () => {
    const newMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newMode);
    try {
      window.localStorage.setItem('themeMode', newMode);
    } catch {
      // Handle error
    }
  };

  const updateTheme = (updates) => {
    setCustomTheme((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const value = useMemo(
    () => ({
      themeMode,
      themeToggler,
      customTheme,
      updateTheme, // Make sure this is included in the context value
    }),
    [themeMode, customTheme],
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return context;
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
